import { render, staticRenderFns } from "./HorizontalCard.vue?vue&type=template&id=6b013aaf&scoped=true"
import script from "./HorizontalCard.vue?vue&type=script&lang=js"
export * from "./HorizontalCard.vue?vue&type=script&lang=js"
import style0 from "./HorizontalCard.vue?vue&type=style&index=0&id=6b013aaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b013aaf",
  null
  
)

export default component.exports